const _updateButtonParams = () => {
  const $joinBtnAnchor = document.querySelector("#become-insider-btn");
  const {href, search} = window.location;
  const params = "?referer=" + encodeURIComponent(href) + (search ? search.replace("?", "&") : "");

  $joinBtnAnchor.href = $joinBtnAnchor.href + params;
}

window.addEventListener("DOMContentLoaded", _updateButtonParams);
